import { useState } from 'react'
import { Button, TextInput } from '@ordr-as/umami-react'
import { CloseIcon, SearchIcon } from '@ordr-as/icons'

const Search = ({
    placeHolder = 'Search',
    onSubmit,
    onCancel,
    initialValue = '',
}: {
    initialValue?: string
    onSubmit: (query: string) => void
    onCancel: () => void
    placeHolder: string
}) => {
    const [value, setValue] = useState(initialValue)
    return (
        <form id="searchForm" className="flex justify-end mt-2">
            <TextInput
                className="align-top mr-3 flex"
                value={value}
                placeholder={placeHolder}
                aria-label={placeHolder}
                onChange={(value) => setValue(value)}
                fullWidth
                IconElement={value ? CloseIcon : undefined}
                onIconClick={onCancel}
            />
            <Button
                type="submit"
                kind="primary"
                aria-label="Search"
                onClick={(e) => {
                    if (e) {
                        e.preventDefault()
                    }
                    onSubmit(value)
                }}
            >
                <SearchIcon />
            </Button>
        </form>
    )
}

export default Search
